import React, { Component } from "react";
import moment from "moment-timezone";

// CSS
import "../../css/display-table.css";

import { connect } from "react-redux";
import {
	registerReviewerToRegistration,
	clearRegistrationResults
} from "../../store/actions/registration";

import { alerts } from "../utils/dialogs/Alerts";

class SearchReviewers extends Component {
	constructor(props) {
		super(props);

		this.state = {
			registerSuccessMessage: ""
		};
	}

	async registerReviewerToReview(reviewerId) {
		let response = await this.props.registerReviewerToRegistration(
			this.props.reviewId,
			reviewerId
		);
		if (response) {
			this.setState({ registerSuccessMessage: response.data.data.message });
			this.props.alert.success(response.data.data.message);
			window.location.reload();
		} else {
			this.props.alert.error("This reviewer is already set to this review.");
		}
	}

	render() {
		// Use either id or some other index name passed as prop
		const indexUsed = this.props.index ? this.props.index : "id";
		// let registerSuccessMessage = (
		// 	<div className="success-wrap">{this.state.registerSuccessMessage}</div>
		// );
		return (
			// { registerSuccessMessage },
			<React.Fragment>
				{this.props.items.length ? (
					<table className="display_table">
						<thead>
							<tr className="table-header">
								<th />
								<th>Name</th>
								<th>Email</th>
								<th>Joined</th>
								<th>Type</th>
								<th>Status</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{this.props.items.map((item, i) => (
								<tr
									className="clickable"
									key={i}
									onClick={() =>
										this.props.history.push(
											this.props.basePath + "/" + item[indexUsed]
										)
									}
								>
									<td className="record-number">
										{i + this.props.startPosition + 1}
									</td>
									<td data-id="Name">
										{item.fname} {item.lname}
									</td>
									<td data-id="Email">{item.email}</td>
									<td data-id="Joined">
										{moment
											.utc(item.date_added)
											.local()
											.format("MMM D, Y")}
									</td>
									<td data-id="Type">{item.account_accepted_text}</td>
									<td data-id="Status">{item.status_text}</td>
									<td className="edit-cell">
										{/* <div
											onClick={() =>
												this.props.registerReviewerToRegistration(
													this.props.reviewId,
													item[indexUsed]
												)
											}
											className="edit_btn"
										>
											Add
										</div> */}
										<div
											onClick={() =>
												this.registerReviewerToReview(item[indexUsed])
											}
											className="edit_btn"
										>
											Add
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div>No Results</div>
				)}
			</React.Fragment>
		);
	}
}

SearchReviewers.defaultProps = {
	items: [],
	startPosition: 0,
	clickHandle: null
};

const mapStateToProps = state => {
	return {
		translations: state.translations.translations
	};
};

export default alerts(
	connect(
		mapStateToProps,
		{ registerReviewerToRegistration, clearRegistrationResults }
	)(SearchReviewers)
);



// WEBPACK FOOTER //
// ./src/components/search/SearchReviewersToAdd.js